import clsx from 'clsx';
import React from 'react';
import { getStatusStyle } from '../utils/statusStyles';

type StatusCategory =
  | 'DRAFT'
  | 'NEW'
  | 'RESUBMIT'
  | 'IP'
  | 'LOCKED'
  | 'CMPLT'
  | 'CLOSED'
  | 'ERROR'
  | string;

interface StatusPillProps {
  status: string;
  category?: StatusCategory;
  className?: string;
  text?: string;
  small?: boolean;
}

export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  category,
  className,
  text,
  small,
}) => {
  const statusClass = getStatusStyle(category);

  return (
    <span
      className={clsx(
        'tw:rounded-full tw:border tw:text-center',
        small
          ? 'tw:text-[10px]/4 tw:px-[calc(theme(spacing[1.5])-1px)] tw:py-[1px]'
          : 'tw:text-xs tw:px-2 tw:py-1',
        statusClass,
        className
      )}
    >
      {text || status}
    </span>
  );
};

export default StatusPill;
